export enum ExcelDataTypeEnum {
  String = 'String',
  Formula = 'Formula',
  Number = 'Number',
  Boolean = 'Boolean',
  DateTime = 'DateTime',
  Error = 'Error',
}
